export class PlayerData {
  constructor({
    id,
    number,
    country,
    name,
    gender,
    target,
    turn1,
    turn2,
    turn3,
    turn4,
    turn5,
  }) {
    this.id = id || "";
    this.number = number || "";
    this.country = country || "";
    this.name = name || "";
    this.gender = gender || "";
    this.target = target || "";
    this.turn1 = turn1 || "";
    this.turn2 = turn2 || "";
    this.turn3 = turn3 || "";
    this.turn4 = turn4 || "";
    this.turn5 = turn5 || "";
  }

  static fromJson(json) {
    return new PlayerData({
      id: json.id || json.player_id || "",
      number: json.number || "",
      country: json.country || "",
      name: json.name || json.player_name || "",
      gender: json.gender || "",
      target: json.target || json.target_number || "",
      turn1: json.turn1 || "",
      turn2: json.turn2 || "",
      turn3: json.turn3 || "",
      turn4: json.turn4 || "",
      turn5: json.turn5 || "",
    });
  }

  get genderLabel() {
    return this.gender === "M"
      ? "Man"
      : this.gender === "W" || this.gender === "F"
      ? "Woman"
      : "";
  }
}
